import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalOutlet } from '@/shared/ui/modal/modal-outlet';

@Component({
  selector: 'dialab-root',
  imports: [RouterOutlet, ModalOutlet],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
